import { createUseStyles } from 'react-jss';
import { Spacings } from '@picsart/design-system/foundation/spacings';
import { BackgroundColors } from '@picsart/design-system/foundation/backgroundColors';
import { BREAKPOINTS } from '@/styles/theme';

const useStyles = createUseStyles(
  {
    header: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      padding: [Spacings.s12, Spacings.s16],
      backgroundColor: BackgroundColors.base,
      position: 'sticky',
      top: 0,
      zIndex: 100,
      [`@media (max-width: ${BREAKPOINTS.smallMobile}px)`]: {
        padding: [Spacings.s8, Spacings.s12],
      },
    },
  },
  { name: 'header' }
);

export default useStyles;
